// @flow

export type TagTypeKey = 'region' | 'group' | 'territory';

export type TagTypeMeta = {
  key: string,
  label: string,
  color: string,
};

export const TAG_TYPES: TagTypeMeta[] = [
  { key: 'region', label: 'Region', color: '#137cbd' },
  { key: 'group', label: 'Group', color: '#2F53A3' },
  { key: 'territory', label: 'Territory', color: '#0e7c66' },
];

export const findTagTypeMeta = (
  tagTypes: TagTypeMeta[],
  key: string,
): TagTypeMeta =>
  tagTypes.find((t) => t.key === key) || {
    key,
    label: key,
    color: '#5c7080',
  };
